import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {RouterLink} from '@angular/router';
import {InvoiceCardComponent} from '../invoice-card/invoice-card.component';
import {PageViewModel} from '@components/ui/table-template/models/page-view-model';
import {InvoiceSummaryViewModel} from '../view-models/invoice-summary-view.model';

@Component({
    selector: 'app-invoice-summary-card-container',
    templateUrl: './invoice-card-container.component.html',
    styleUrls: ['./invoice-card-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, InvoiceCardComponent]
})
export class InvoiceCardContainerComponent {
  public readonly currentPage = input.required<PageViewModel<InvoiceSummaryViewModel>>();
  public readonly clickableRows = input<boolean>(true);
}
